import { RAG } from 'features/dashboard/charts/scoreColour'

export const PRIORITY_LEVELS = ['critical', 'high', 'medium', 'low']

export const PRIORITY_META = {
  critical: { label: 'Critical', fg: RAG.critical.fg, bg: RAG.critical.bg, hint: 'Do this first. Leaving it risks safety or breaking the law.' },
  high:     { label: 'High',     fg: RAG.high.fg,     bg: RAG.high.bg,     hint: 'Important. Do it soon, ahead of routine work.' },
  medium:   { label: 'Medium',   fg: RAG.medium.fg,   bg: RAG.medium.bg,   hint: 'Routine work. Get it done by its deadline.' },
  low:      { label: 'Low',      fg: RAG.low.fg,      bg: RAG.low.bg,      hint: 'Can wait. Do it when there is time.' },
}

export const priorityKey = value => {
  const key = String(value || '').toLowerCase()
  return key === 'urgent' ? 'critical' : key
}

export const priorityMeta = value => PRIORITY_META[priorityKey(value)] || null

